import {
  GetWorkSpacesWithBookingsDocument,
  UpsertWorkAreaMapSpaceLocationDocument,
  UpsertWorkAreaMapSpaceLocationMutation,
  UpsertWorkAreaMapSpaceLocationMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpsertWorkAreaMapSpaceLocation = () => {
  const [executeMutation, { loading }] = useMutation(UpsertWorkAreaMapSpaceLocationDocument, {
    extractorFn: (data: UpsertWorkAreaMapSpaceLocationMutation) =>
      data.spaceControlMutations.upsertSpacecontrolWorkAreaMapSpaceLocation,
  })

  const upsertWorkAreaMapSpaceLocation = async (
    variables: UpsertWorkAreaMapSpaceLocationMutationVariables
  ) => {
    return executeMutation({
      variables,
      refetchQueries: [GetWorkSpacesWithBookingsDocument],
    })
  }

  return {
    upsertWorkAreaMapSpaceLocation,
    loading,
  }
}
